// import React from "react";
// import { Layout, Button } from "antd";
// import { LeftOutlined } from "@ant-design/icons";
// import { useNavigate, useLocation } from "react-router-dom";
// import { getHeaderBarColor } from "../../../utils/getHeaderBarColor";

// const { Header } = Layout;

// const HeaderBack = ({ modulo, data, acciones, onBack }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   if (!data) {
//     return null;
//   }

//   const handleBack = () => {
//     if (onBack) {
//       onBack();
//       return;
//     }
//     // Regla especifica para el módulo de stock: si estamos en una ruta que incluye "/consultar-stock", volvemos a "/home" en lugar de la ruta anterior
//     if (location.pathname.includes("/consultar-stock")) {
//       navigate("/home");
//       return;
//     }

//     const segments = location.pathname.split("/").filter(Boolean);
//     if (segments.length > 1) {
//       segments.pop();
//       navigate("/" + segments.join("/"));
//     } else {
//       navigate(-1);
//     }
//   };

//   const barColor = getHeaderBarColor(modulo);

//   return (
//     <Header
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         paddingInline: "16px",
//         zIndex: 100,
//         position: "sticky",
//         width: "100%",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//         }}
//       >
//         <Button
//           onClick={handleBack}
//           type="text"
//           icon={
//             <LeftOutlined
//               style={{ fontSize: "31px", color: "white" }}
//               onClick={handleBack}
//             />
//           }
//         />

//         {/* Barra vertical según módulo */}
//         {data?.headerTitle && (
//           <>
//             <div
//               style={{
//                 width: "6px",
//                 height: "24px",
//                 backgroundColor: barColor,
//                 borderRadius: "2px",
//               }}
//             />
//             <div
//               style={{
//                 color: "white",
//                 fontWeight: "bold",
//                 fontSize: "19px",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               {data.headerTitle}
//             </div>
//           </>
//         )}
//       </div>

//       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//         {acciones}
//       </div>
//     </Header>
//   );
// };

// export default HeaderBack;

import React from "react";
import { Layout, Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { getHeaderBarColor } from "../../../utils/getHeaderBarColor";

const { Header } = Layout;

const HeaderBack = ({ modulo, data, acciones, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isSmallDevice = window.innerWidth <= 320;

  if (!data) {
    return null;
  }

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    // Regla específica para el módulo de stock
    if (location.pathname.includes("/consultar-stock")) {
      navigate("/home");
      return;
    }

    const segments = location.pathname.split("/").filter(Boolean);

    if (segments.length > 1) {
      segments.pop();
      navigate("/" + segments.join("/"));
    } else {
      navigate(-1);
    }
  };

  const barColor = getHeaderBarColor(modulo);

  return (
    <Header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingInline: "16px",
        zIndex: 100,
        position: "sticky",
        width: "100%",
      }}
    >
      {/* IZQUIERDA */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Button
          onClick={handleBack}
          type="text"
          icon={
            <LeftOutlined
              style={{
                fontSize: "31px",
                color: "white",
              }}
            />
          }
        />

        {data?.headerTitle && (
          <>
            <div
              style={{
                width: "6px",
                minWidth: "6px",
                height: "24px",
                backgroundColor: barColor,
                borderRadius: "2px",
              }}
            />

            <div
              style={{
                color: "white",
                fontWeight: "bold",
                fontSize: isSmallDevice ? "15px" : "19px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={data.headerTitle}
            >
              {data.headerTitle}
            </div>
          </>
        )}
      </div>

      {/* DERECHA */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexShrink: 0,
        }}
      >
        {acciones}
      </div>
    </Header>
  );
};

export default HeaderBack;
